/**
 * Page Skeleton Component
 *
 * Loading skeleton for page content
 * Better UX than spinner for content-heavy pages
 */
import { Skeleton, Card } from 'antd';
import './PageSkeleton.css';

interface PageSkeletonProps {
  rows?: number;
  showHeader?: boolean;
  showTable?: boolean;
}

/**
 * Displays skeleton loading state for pages
 * Can be customized for different page layouts
 */
export const PageSkeleton: React.FC<PageSkeletonProps> = ({
  rows = 5,
  showHeader = true,
  showTable = false,
}) => {
  return (
    <div className="page-skeleton" style={{ padding: '24px' }}>
      {showHeader && (
        <div style={{ marginBottom: '24px' }}>
          <Skeleton.Input
            active
            size="large"
            style={{ width: '300px', marginBottom: '16px' }}
          />
          <Skeleton.Input active style={{ width: '500px' }} />
        </div>
      )}

      {showTable ? (
        <Card>
          <Skeleton active paragraph={{ rows }} />
          <div style={{ marginTop: '16px' }}>
            <Skeleton.Button active style={{ marginRight: '8px' }} />
            <Skeleton.Button active style={{ marginRight: '8px' }} />
            <Skeleton.Button active />
          </div>
        </Card>
      ) : (
        <Card>
          <Skeleton active paragraph={{ rows }} />
        </Card>
      )}
    </div>
  );
};

export default PageSkeleton;
